import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-page-category-update',
  templateUrl: './page-category-update.component.html',
  styleUrls: ['./page-category-update.component.css']
})
export class PageCategoryUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/page-cat/page-cat-update/page-category-update.component.ts